"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _events = require("./events");

var showComponentsInViewport = function showComponentsInViewport(windowScroll) {
  var breakOut = false;
  setTimeout(function () {
    Array.from(document.querySelectorAll('#wrapper #content .component, #wrapper #footer')).each(function (el) {
      if (breakOut) return;
      var rect = el.getBoundingClientRect();
      var offset = {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft
      };
      var wh = parseFloat(getComputedStyle(document.querySelector('window'), null).height.replace('px', ''));

      var showComponent = function showComponent(component) {
        if (!component.classList.contains('animate')) {
          component.classList.add('animate');
          var trackingName = component.getAttribute('data-tracking-name');

          if (trackingName !== undefined) {
            (0, _events.triggerEvent)('trackElementReached', trackingName);
          }
        }
      };

      if ((el.classList.contains('component-ready') || el.getAttribute('id') === 'footer') && offset.top - wh < windowScroll) {
        showComponent(el);
      } else if (el.classList('link-to-previous')) {
        showComponent(el);
      }
    });
  }, 0);
};

var _default = showComponentsInViewport;
exports["default"] = _default;